import script from "./EmpDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./EmpDocuments.vue?vue&type=style&index=0&id=6018de02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6018de02"]])

export default __exports__